module.exports = global["$"] = require("-!/Users/tarex/Codes/HTML/turbo-html/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?$!./~/jquery/dist/jquery.js
 ** module id = 16
 ** module chunks = 0
 **/